'use client';

import { Button } from '@/components/ui/button';
import { defaultFilterTypes, ShowSearch } from '@/lib/frontend/store/actionCreators/SearchActions';
import { useAppStore } from '@/lib/frontend/store/hooks';
import { Search } from 'lucide-react';
import React from 'react';

export const HeaderSearchButton = () => {
  const store = useAppStore();
  return (
    <Button
      size="icon"
      onClick={() =>
        ShowSearch(store, {
          filterTypes: defaultFilterTypes,
        })
      }
      variant="ghost"
      className="rounded-full"
      aria-label="Search"
    >
      <Search className="w-4 h-4" />
    </Button>
  );
};
